import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import { useSelector } from 'react-redux';

import { VideaTypography } from '../../../common-components/elements/VideaTypography/VideaTypography';
import { videaInsightsScreens } from '../../../constants';
import { useGetInsightsSummary } from '../../../react-query/useGetInsightsSummary';
import {
  blueBlack640,
  green400,
  greyLight400,
} from '../../../theme/videa-style-tokens';
import { getCurrentDate, getFirstDateOfMonth } from '../../../utils/date.util';
import { tractMixpanelEvent } from '../common/mixPanelUtils';
import OverallPerformance from '../common/overallPerformance/OverallPerformance';
import RefreshTimeStamp from '../common/refreshTimeStamp/RefreshTimeStamp';
import { FINE_PRINT, REVENUE } from '../constants';
import { TopBottomLocations } from '../topBottomLocations/TopBottomLocations';

const date = new Date();
const currentMonth = date.toLocaleString('default', { month: 'long' });
const currentYear = date.getFullYear();

const InsightsContainer = styled.div`
  position: relative;

  .info {
    margin: 1.5em 0 0;
  }
  .title {
    color: ${blueBlack640};
    font-weight: 500;
  }
  .period {
    margin: 0 0.5em;
    font-size: 1.5em;
    font-weight: 400;
    color: ${blueBlack640};
  }
  .header: {
    color: ${greyLight400};
    font-size: 1em;
  }
  .fine-print {
    position: absolute;
    right: 0;
    top: 0;
    width: 16em;
    height: 1.5em;
    font-size: 0.75em;
    color: ${green400};
    line-height: 1;
    text-align: right;
  }
`;

const Home = () => {
  const user = useSelector((state: any) => state?.login?.user);
  const { data: summary } = useGetInsightsSummary({
    organizationId: user.primaryOrganizationId,
    startDate: getFirstDateOfMonth(),
    endDate: getCurrentDate(),
  });

  tractMixpanelEvent(user, videaInsightsScreens.organizationProfile);

  return (
    <InsightsContainer>
      <div className="info">
        <VideaTypography variant="headingSmall" className="title">
          <Trans>Restorative Tx Metrics</Trans>
        </VideaTypography>
        <VideaTypography variant="headingSmall" className="period">
          {`${currentMonth} ${currentYear}`}
        </VideaTypography>
        <div className="fine-print">{FINE_PRINT}</div>
      </div>
      <OverallPerformance insights={summary} />
      <TopBottomLocations user={user} sortBy={REVENUE} />
      <RefreshTimeStamp timeStamp={''} />
    </InsightsContainer>
  );
};

export default Home;
